import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=c9d29338&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d29338')) {
      api.createRecord('c9d29338', component.options)
    } else {
      api.reload('c9d29338', component.options)
    }
    module.hot.accept("./AccordionItem.vue?vue&type=template&id=c9d29338&", function () {
      api.rerender('c9d29338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/AccordionItem.vue"
export default component.exports